<template>
  <div class="balance-history-chart">
    <div
      v-if="!rows.length"
      class="balance-history-chart__empty text-muted text-center py-5"
    >
      Нет данных для отображения
    </div>
    <div v-show="rows.length" ref="chart"></div>
  </div>
</template>

<script>
  import c3 from 'c3'
  import Visibility from 'visibilityjs'
  import api from '@/api'

  export default {
    props: {
      endpoint: {
        type: String,
        required: true,
      },
      days: {
        type: Number,
        default: 30,
      },
      from: {
        type: String,
        default: null,
      },
      to: {
        type: String,
        default: null,
      },
      height: {
        type: Number,
        default: 420,
      },
    },
    data () {
      return {
        rows: [],
        chart: null,
      }
    },
    computed: {
      queryParams () {
        const params = {
          days: this.days,
        }

        if (this.from) {
          params.from = this.from
        }

        if (this.to) {
          params.to = this.to
        }

        return params
      },
    },
    asyncComputed: {
      fetched () {
        return api.get(this.endpoint, {
          params: this.queryParams,
        }).then(({data}) => data.data || [])
      },
    },
    watch: {
      fetched (value) {
        this.rows = value
        this.renderChart()
      },
      days () {
        this.reload()
      },
      from () {
        this.reload()
      },
      to () {
        this.reload()
      },
      endpoint () {
        this.reload()
      },
    },
    methods: {
      reload () {
        if (this.$asyncComputed && this.$asyncComputed.fetched) {
          this.$asyncComputed.fetched.update()
        }
      },
      destroyChart () {
        if (this.chart) {
          this.chart.destroy()
          this.chart = null
        }
      },
      renderChart () {
        if (!this.rows.length) {
          this.destroyChart()
          return
        }

        const columns = this.prepareColumns(this.rows)

        this.destroyChart()
        this.chart = c3.generate({
          bindto: this.$refs.chart,
          size: {
            height: this.height,
          },
          data: {
            x: 'x',
            columns,
            types: {
              refill: 'bar',
              write_off: 'bar',
              balance: 'spline',
            },
            names: {
              refill: 'Пополнения',
              write_off: 'Списания',
              balance: 'Баланс',
            },
            axes: {
              balance: 'y2',
            },
            colors: {
              refill: '#00a0e3',
              write_off: '#bf3030',
              balance: '#08588f',
            },
            order: null,
          },
          axis: {
            x: {
              type: 'timeseries',
              tick: {
                fit: true,
                format: '%Y-%m-%d',
              },
            },
            y: {
              label: {
                text: 'Операции, ₽',
                position: 'outer-middle',
              },
              padding: {
                top: 0,
                bottom: 0,
              },
            },
            y2: {
              label: {
                text: 'Баланс, ₽',
                position: 'outer-middle',
              },
              show: true,
              padding: {
                top: 0,
                bottom: 0,
              },
            },
          },
          bar: {
            width: {
              ratio: 0.6,
            },
          },
          tooltip: {
            format: {
              value (value, ratio, id) {
                const raw = id === 'write_off' ? Math.abs(value) : value
                return raw.toFixed(2)
              },
            },
          },
          grid: {
            y: {
              show: true,
            },
          },
        })

        Visibility.onVisible(() => {
          this.chart && this.chart.flush()
        })
      },
      prepareColumns (rows) {
        const dates = ['x']
        const refill = ['refill']
        const writeOff = ['write_off']
        const balance = ['balance']

        rows.forEach((row) => {
          dates.push(row.date)
          refill.push(Number(row.refill || 0))
          writeOff.push(-Math.abs(Number(row.write_off || 0)))
          balance.push(Number(row.balance || 0))
        })

        return [dates, refill, writeOff, balance]
      },
    },
    beforeDestroy () {
      this.destroyChart()
    },
  }
</script>

<style lang="scss">
  @import "~c3/c3.css";

  .balance-history-chart {
    position: relative;
  }

  .balance-history-chart__empty {
    min-height: 200px;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/billing/balance-history-chart.vue